export default {
  date: {
    abbr_day_names: [
      'dim',
      'lun',
      'mar',
      'mer',
      'jeu',
      'ven',
      'sam',
    ],
    abbr_month_names: [
      null,
      'jan.',
      'fév.',
      'mar.',
      'avr.',
      'mai',
      'juin',
      'juil.',
      'août',
      'sept.',
      'oct.',
      'nov.',
      'déc.',
    ],
    day_names: [
      'dimanche',
      'lundi',
      'mardi',
      'mercredi',
      'jeudi',
      'vendredi',
      'samedi',
    ],
    formats: {
      default: 'YYYY-MM-DD',
      long: 'D MMMM YYYY',
      short: 'YY-MM-DD',
    },
    month_names: [
      null,
      'janvier',
      'février',
      'mars',
      'avril',
      'mai',
      'juin',
      'juillet',
      'août',
      'septembre',
      'octobre',
      'novembre',
      'décembre',
    ],
    order: [
      'year',
      'month',
      'day',
    ],
  },
  time: {
    am: 'am',
    formats: {
      default: 'HH [h] mm [min] ss [s]',
      long: 'dddd D MMMM YYYY HH [h] mm',
      short: 'HH [h] mm',
    },
    pm: 'pm',
  },
  datetime: {
    distance_in_words: {
      about_x_hours: {
        one: 'environ une heure',
        other: 'environ %{count} heures',
      },
      about_x_months: {
        one: 'environ un mois',
        other: 'environ %{count} mois',
      },
      about_x_years: {
        one: 'environ un an',
        other: 'environ %{count} ans',
      },
      almost_x_years: {
        one: "presqu'un an",
        other: 'presque %{count} ans',
      },
      half_a_minute: 'une demi-minute',
      less_than_x_minutes: {
        one: "moins d'une minute",
        other: 'moins de %{count} minutes',
        zero: "moins d'une minute",
      },
      less_than_x_seconds: {
        one: "moins d'une seconde",
        other: 'moins de %{count} secondes',
        zero: "moins d'une seconde",
      },
      over_x_years: {
        one: "plus d'un an",
        other: 'plus de %{count} ans',
      },
      x_days: {
        one: '1 jour',
        other: '%{count} jours',
      },
      x_minutes: {
        one: '1 minute',
        other: '%{count} minutes',
      },
      x_months: {
        one: '1 mois',
        other: '%{count} mois',
      },
      x_seconds: {
        one: '1 seconde',
        other: '%{count} secondes',
      },
    },
    prompts: {
      day: 'Jour',
      hour: 'Heure',
      minute: 'Minute',
      month: 'Mois',
      second: 'Seconde',
      year: 'Année',
    },
  },
};
